import React from 'react';
import { Button, Slide } from '@material-ui/core';
import ShowChartIcon from '@mui/icons-material/ShowChart';

import { black, lightGray, white, green, greenTint, gray3 } from 'utils/color-styles';

const StatsSection = ({
  children,
  openCta = 'Totals',
  closeCta = 'Hide',
  buttonToggledBorderColor = green,
  slideBackgroundColor = greenTint,
}: {
  children: React.ReactNode;
  openCta: string;
  closeCta: string;
  buttonToggledBorderColor: string;
  slideBackgroundColor: string;
}): JSX.Element => {
  const [open, setOpen] = React.useState(false);
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        overflow: 'hidden',
        background: open ? slideBackgroundColor : 'inherit',
        borderRight: open ? `1px ${slideBackgroundColor} solid` : 'inherit',
        borderRadius: 20,
        borderBottomRightRadius: 20,
      }}
    >
      <Slide direction="left" in={open} unmountOnExit>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            padding: '0 7px',
            paddingLeft: '15px',
          }}
        >
          {children}
        </div>
      </Slide>
      <Button
        aria-label="expand stats"
        onClick={(): void => setOpen(!open)}
        style={{
          borderColor: open ? buttonToggledBorderColor : lightGray,
          backgroundColor: white,
          marginLeft: 4,
          fontSize: 12,
          color: black,
        }}
        endIcon={<ShowChartIcon style={{ color: gray3, display: 'inline-block' }} />}
      >
        {open ? closeCta : openCta}
      </Button>
    </div>
  );
};

export default StatsSection;
